module.exports = function() {
  return new Worker(__webpack_public_path__ + "4aef7ec80a55c33516d0.worker.js");
};